module.exports = __webpack_public_path__ + "img/senior1.02169e94.png";